import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

interface LoadingStateProps {
    label: string;
    height?: string | number;
    spinnerSize?: string | number;
}

export const LoadingState = ({ label, height = '80vh', spinnerSize = '6rem' }: LoadingStateProps) => (
    <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height={height}
    >
        <CircularProgress size={spinnerSize} />
        <Typography variant="h6" sx={{ mt: 2 }}>
            {label}
        </Typography>
    </Box>
);
